<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [imageURL]="
              employee.coverUrl
                ? employee.coverUrl
                : '/assets/images/default_avatar.jpg'
            "
            [mode]="'avatar'"
            (onClick)="edit(employee)"
          ></ngx-view-user-display>
        </div>

        <div>
          <a
            *ngIf="employee?.fullName"
            class="text-body link"
            (onClick)="loadContent(true)"
          >
            <h6>{{ employee.fullName }}</h6>
          </a>

          <div *ngIf="employee.tags?.length > 0" class="text-link">
            <ngx-view-tags
              [tags]="employee.tags"
              (onTagSelected)="tagSelected($event)"
            ></ngx-view-tags>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <button
        nbButton
        ghost
        shape="round"
        status="primary"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        [nbContextMenu]="menuItems"
        [nbContextMenuTag]="'action-buttons-' + employee.id"
        (click)="loadButtonAction(employee)"
      >
        <nb-icon icon="more-horizontal-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="content">
      <a
        *ngIf="employee?.mobile"
        href="tel:{{ employee.mobile }}"
        class="text-primary link"
      >
        <nb-icon icon="phone-call-outline"></nb-icon> {{ employee.mobile }}
      </a>

      <a
        *ngIf="employee?.email"
        href="mailto:{{ employee.email }}"
        class="text-primary link"
      >
        <nb-icon icon="email-outline"></nb-icon> {{ employee.email }}
      </a>
    </div>

    <a *ngIf="!isMore" (click)="loadContent(true)" class="link text-link">
      <nb-icon icon="chevron-down-outline"></nb-icon>
      Mở rộng
    </a>

    <nb-card *ngIf="isMore">
      <nb-card-body>
        <ul class="detail">
          <li *ngIf="employee.gender">
            {{ "common.gender" | translate }}:
            <span class="text-hint"> {{ employee.gender }}</span>
          </li>
          <li *ngIf="employee.dob">
            {{ "person.dob" | translate }}:
            <span class="text-hint">
              {{ employee.dob | date: "dd/MM/yyyy" }}</span
            >
          </li>
          <li *ngIf="employee.cardId">
            CMND: <span class="text-hint"> {{ employee.cardId }}</span>
          </li>
          <li *ngIf="employee.tax">
            {{ "person.tax" | translate }}:
            <span class="text-hint"> {{ employee.tax }}</span>
          </li>
          <li *ngIf="employee.address">
            {{ "common.address" | translate }}:<span class="text-hint">
              {{ employee.address }}
            </span>
          </li>
          <li *ngIf="employee.description">
            {{ "common.note" | translate }}:
            <span class="text-hint" style="white-space: pre">{{
              employee.description
            }}</span>
          </li>
        </ul>
        <ngx-view-gallery
          *ngIf="employee.imagesUrl?.length > 0"
          [imagesUrl]="employee.imagesUrl"
        >
        </ngx-view-gallery>
      </nb-card-body>
    </nb-card>
    <div class="content">
      <a *ngIf="isMore" (click)="loadContent(false)" class="link text-link">
        <nb-icon icon="chevron-up-outline"></nb-icon>
      </a>

      <div *ngIf="isMore" class="button-action">
        <button
          nbButton
          ghost
          status="danger"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="delete(employee)"
        >
          <nb-icon icon="trash-2-outline"></nb-icon>
        </button>

        <button
          nbButton
          ghost
          status="info"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="edit(employee)"
        >
          <nb-icon icon="edit-2-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-body>

  <!-- <nb-card-footer>
    <div class="button-actions">
      <button
        *ngIf="mode != 'employee'"
        nbButton
        ghost
        status="success"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="createHistory(employee)"
      >
        <nb-icon icon="file-text-outline"></nb-icon>
        <span *ngIf="!isMobile"> Tạo nhật ký</span>
        <span *ngIf="isMobile"> Nhật ký</span>
      </button>

      <button
        *ngIf="mode != 'employee'"
        nbButton
        ghost
        size="small"
        status="info"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="viewHistory(employee)"
      >
        <nb-icon icon="calendar-outline"></nb-icon>
        <span *ngIf="!isMobile"> Xem lịch sử</span>
        <span *ngIf="isMobile"> Lịch sử</span>
      </button>
    </div>
  </nb-card-footer> -->
</nb-card>
